export default {"src":"/_next/static/media/loan-settled.4ee9e117.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};